// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Query_wrapper__3xAei","row":"Query_row__2h-oe"};